module.exports = __webpack_public_path__ + "39b2d063adce92402a5445937c86e2dd.svg";